module.exports = __webpack_public_path__ + "assets/img/16_1743.b3152136.jpg";